import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from "axios";
import { Toaster, toast } from "sonner";
import Select from 'react-select';
import { FaCircleXmark } from "react-icons/fa6";
import {
  loadingToggleAction,
  studentLoginAction,
} from "../../store/actions/AuthActions";

// image
import BgImage from "../../images/bg1.png";
import logo from "../../images/gurusidebar.png";
import logolight from "../../images/logo-white.png";
import pol from "../../images/pol.jpg";
import { API_BASE_URL } from "../../utils/constants";
import { isOk, loginObjData } from "../../utils/ResuableFuncction";
import { runLogoutTimer, saveTokenInLocalStorage } from "../../services/AuthService";
import { Spinner } from "react-bootstrap";

let errorsObj = {
  name: "",
  phone: "",
  password: "",
  confirmpassword: "",
};

function StudentRegister(props) {
  const [name, setName] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [otpVerifyLoader, setOtpVerifyLoader] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [source] = useState("LoginAsWeb"); // Source value is fixed
  const [password, setPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState(errorsObj);
  const [loader, setLoader] = useState(false);

const [isOtpInputVisible, setIsOtpInputVisible] = useState(false);
const [otp, setOtp] = useState("");
const [classes, setClasses] = useState([]);
const [selectedClass, setSelectedClass] = useState(null); // To store selected class


  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/class/list`);
        if (response.data.status && response.data.data) {
          // Map API response to react-select compatible format
          const classOptions = response.data.data.map((item) => ({
            value: item.id, // Use 'id' as the value
            label: item.name, // Show 'name' in the dropdown
          }));
          setClasses(classOptions);
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClasses();
  }, []);

  const handleClassChange = (selectedOption) => {
    setSelectedClass(selectedOption);
    console.log("Selected Class:", selectedOption);
  };


const handleTabClick = (path) => {
  navigate(path);
};

const validatePasswords = () => {
    const newErrors = {};
    
    if (!password) {
      newErrors.password = "Password is required.";
    }
  
    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
  
    setErrors(newErrors);
  
    return Object.keys(newErrors).length === 0;
  };

  const handleGetOtpVerification = async () => {
    if (!phone || phone.length < 10) {
      setErrors({ ...errors, phone: "Please enter a valid phone number." });
      return;
    }
  
    try {
      setOtpLoader(true);
      // Trigger phone verification process
      const response = await axios.post(`${API_BASE_URL}/api/send-otp`, { phone });
  
      // Clear errors and show OTP input field
      setErrors({ ...errors, phone: "" });
      setIsOtpInputVisible(true);
      setOtpLoader(false);
    } catch (error) {
      setOtpLoader(false);
      console.error("Error sending OTP:", error.response?.data || error.message);
      setErrors({ ...errors, phone: "Failed to send OTP. Please try again." });
    }
  };

  const handlePhoneVerification = async () => {
    if (!otp || otp.length < 4) {
      alert("Please enter a valid OTP.");
      return;
    }
  
    setOtpVerifyLoader(true); // Start loader
    try {
      const response = await axios.post(`${API_BASE_URL}/api/verify-otp`, { otp, phone:phone });
  
      // Proceed based on API response
      if (response.status === 200) {
        setOtpVerifyLoader(false);
        toast.success("OTP verified successfully!");
        setOtpVerified(true); // Mark as verified
      } else {
        toast.error("Failed to verify OTP.");
      }
    } catch (error) {
      toast.error("Error verifying OTP. Please try again.");
    } finally {
      setOtpVerifyLoader(false); // Stop loader
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

//   useEffect(() => {
//     // Load saved credentials from localStorage
//     const savedEmail = localStorage.getItem("student_email");
//     const savedPassword = localStorage.getItem("student_password");
//     if (savedEmail && savedPassword) {
//       setEmail(savedEmail);
//       setPassword(savedPassword);
//       setRememberMe(true);
//     }
//   }, []);

  async function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    if (name === "") {
      errorObj.name = "Name is Required";
      error = true;
    }
    if (phone === "") {
      errorObj.phone = "Phone Number is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) return;

    setLoader(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/student/register`, {
        name,
        email,
        password,
        password_confirmation:confirmPassword,
        phone,
        class_id: selectedClass?.value,
        source, // Include source here
      });
      if (isOk(response?.status)) {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, 21600 * 1000, navigate); // 6 hours
        toast.success(response.data.message);

        // If not remembering, do not clear credentials from localStorage
        // localStorage.removeItem("student_email");
        // localStorage.removeItem("student_password");

        navigate('/student/login');
      }
    } catch (error) {
      console.error("Registration failed:", error);
      toast.error(
        <div>
          <FaCircleXmark style={{ color: 'red', marginRight: '10px' }} />
          {error?.response.data.message}
        </div>
      );
    } finally {
      setLoader(false);
    }
  }

  return (
    <div className="container h-100">
      <div className="row h-100 align-items-center justify-content-center">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="row m-0">
              <div
                  className="col-xl-6 col-md-6 sign text-center sign-bg d-flex align-items-center justify-content-center"
                  style={{
                    backgroundImage: 'linear-gradient(to top, #f7ad34, white)',
                  }}
                >
                  <div>
                    <Link to={"#"} className="d-flex flex-column align-items-center">
                      <img className="logo-abbr dark-logo" width="250" src={logo} alt="Logo" />
                      <p
                        className="fw-bold"
                        style={{
                          fontSize: '2rem',
                          marginTop: '0.5rem', // Adjusts the spacing between the image and text
                          color: '#ffde00',
                          textShadow: '0.5px 0.5px 0px black, -1px 0.5px 0px black, 0.5px -1px 0px black, -1px -1px 0px black'
                        }}
                      >
                        Guru Dakshina
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6">
                  <div className="sign-in-your px-2">
                    <h4 className="fs-20">Register as student</h4>
                    <span>Welcome! fill in with your data to register as student</span>
                     {/* Tabs for Login and Register */}
      <div className="d-flex justify-content-center mb-3 mt-3">
        <button
          className={`btn ${window.location.pathname === "/student/login" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => handleTabClick("/student/login")}
        >
          Login
        </button>
        <button
          className={`btn ms-2 ${window.location.pathname === "/student/register" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => handleTabClick("/student/register")}
        >
          Register
        </button>
      </div>
                    {props.errorMessage && (
                      <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                        {props.errorMessage}
                      </div>
                    )}
                    {props.successMessage && (
                      <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                        {props.successMessage}
                      </div>
                    )}
                    <form onSubmit={onLogin}>
                    <div className="mb-1">
    <label className="mb-1 pt-3"><strong>Full Name</strong></label>
    <input
      type="name"
      className="form-control"
      value={name}
      onChange={(e) => setName(e.target.value)}
      placeholder="Type Your Full Name"
    />
    {errors.name && <div className="text-danger fs-12">{errors.name}</div>}
  </div>
  <div className="mb-1">
    <label className="mb-1 pt-3"><strong>Email (Optional)</strong></label>
    <input
      type="email"
      className="form-control"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Type Your Email Address"
    />
    {errors.email && <div className="text-danger fs-12">{errors.email}</div>}
  </div>
  <div className="mb-1">
    <label className="mb-1 pt-3"><strong>Phone</strong></label>
    <div className="input-group">
      <input
        type="tel"
        className="form-control"
        value={phone}
        onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
        placeholder="Type Your Phone Number"
        maxLength={10}
        inputMode="numeric"
      />
 <button
      type="button"
      className="btn btn-secondary"
      onClick={handleGetOtpVerification}
      disabled={otpLoader} 
    >
      {otpLoader ? (
        <Spinner size={15} /> 
      ) : (
        "Get OTP"
      )}
    </button>
    </div>
    {errors.phone && <div className="text-danger fs-12">{errors.phone}</div>}
  </div>

  {/* OTP Input Field */}
  {isOtpInputVisible && (
    <div className="mb-3">
      <label className="mb-1 pt-3"><strong>OTP</strong></label>
      <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter the OTP"
        maxLength={6}
      />
<button
  type="button"
  className={`btn ms-1 ${otpVerified ? "btn-success" : "btn-secondary"}`}
  onClick={handlePhoneVerification}
  disabled={otpVerifyLoader || otpVerified}
>
  {otpVerifyLoader ? (
    <Spinner size={15} />
  ) : otpVerified ? (
    "Verified"
  ) : (
    "Verify"
  )}
</button>
      </div>
      
      {errors.otp && <div className="text-danger fs-12">{errors.otp}</div>}
    </div>
  )}

<div className="mb-3">
  <label className="mb-1"><strong>Create Password</strong></label>
  <div className="input-group">
    <input
      type={showPassword ? 'text' : 'password'}
      className="form-control"
      value={password}
      placeholder="Type Your Password"
      onChange={(e) => setPassword(e.target.value)}
    />
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
    </button>
  </div>
  {errors.password && <div className="text-danger fs-12">{errors.password}</div>}
</div>

<div className="mb-3">
  <label className="mb-1"><strong>Confirm Password</strong></label>
  <div className="input-group">
    <input
      type={showConfirmPassword ? 'text' : 'password'}
      className="form-control"
      value={confirmPassword}
      placeholder="Confirm Your Password"
      onChange={(e) => setConfirmPassword(e.target.value)}
    />
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    >
      {showConfirmPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
    </button>
  </div>
  {errors.confirmPassword && <div className="text-danger fs-12">{errors.confirmPassword}</div>}
</div>

<div className="mb-3">
      <label className="mb-1"><strong>Select Class</strong></label>
      <Select
        options={classes}
        value={selectedClass}
        onChange={handleClassChange}
        placeholder="Select your class"
        styles={{
          menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
          }),
        }}
      />
    </div>
                       {/* Hidden Input for Source */}
                       <input type="hidden" name="source" value={source} />
                     
                       <div className="text-center">
  {loader ? (
    <button
      className="btn btn-primary btn-block"
      type="button"
      disabled
    >
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Registering...
    </button>
  ) : (
    <button
      type="submit"
      className="btn btn-primary btn-block"
      disabled={!otpVerified} // Disable button until OTP is verified
    >
      Register
    </button>
  )}
</div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};

export default connect(mapStateToProps)(StudentRegister);